export default class Format {

	constructor(id, attributes) {
		this.id = id;
		Object.assign(this, attributes);
		this.name = this.name || '?';
		this.label = this.name;
		this.slug = this.name.toLowerCase().replace(/\s/g, '');
	}

}
